import * as actions from './actions'

const catalogDiagnosticsModule = {
    namespaced: true,
    actions,
}

export default catalogDiagnosticsModule
